module.exports = __webpack_public_path__ + "static/media/facebook-logo.3150680a.svg";